import { useEffect } from 'react';

/**
 * When locale changes, re-run validation so Yup (or other resolver) messages match the new language.
 * Pass the same errors object you get from formState.
 */
export function useRevalidateFormOnLanguageChange(language, trigger, errors) {
  useEffect(() => {
    if (Object.keys(errors || {}).length) {
      void trigger();
    }
  }, [language, trigger]);
}
